<template>
    <CModal class="modal-chooseFile" title="Danh sách Lô/Serial" :show.sync="isShowModal" :closeOnBackdrop="false"
        :size="'xl'">
        <div>
            <CRow>
                <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                    <CCard>
                        <CCardHeader>
                            <CRow class="pb-2">
                                <CCol sm="12" md="12" xl="4" xs="4" style="margin: auto;">
                                    <div class="form-group">
                                        <label>Danh sách Lô/Serial</label>
                                        <br/>

                                        <label><b>Tổng: </b> {{ itemAddSerial.stockProductLotSerials ? itemAddSerial.stockProductLotSerials.length : 0}} bản ghi</label>

                                        

                                    </div>
                                </CCol>
                                <CCol sm="12" md="12" xl="8" xs="8" style="margin: auto;">
                                    <CButton v-if="!isShowScan && !isScanQR" style="float: right;margin-left: 5px;margin-top: 2px; min-width:40px"
                                            color="success" class="btn-action-primary" @click="scanQR()"> <i
                                                class="fa fa-qrcode"></i> Quét QR </CButton>
                                    <CButton v-if="!isShowScan && isScanQR" style="float: right;margin-left: 5px;margin-top: 2px; min-width:40px"
                                        color="warning" class="btn-action-primary" @click="stopScanQR()"> <i
                                            class="fa fa-qrcode"></i> Dừng quét QR </CButton>
                                    <CButton v-if="!isShowScan" style="float: right;margin-left: 5px;margin-top: 2px; min-width:40px"
                                        color="primary" class="btn-action-primary" @click="showAddLine()"> <i
                                            class="fa fa-plus"></i> Thêm mới </CButton>
                                </CCol>
                            </CRow>
                        </CCardHeader>
                        <CCardBody>
                            <CRow class="pb-2">
                                <CCol sm="12" md="12" xl="3" xs="3" style="margin: auto;">
                                    <div class="form-group" v-show="isScanQR == true">
                                        <BaseSelect :options="cameraSelect.options" :data="cameraSelect.data"
                                                ref="cameraSelect">
                                        </BaseSelect>
                                        <div class="mt-2" style="width:100%;position: relative;">
                                            <video id="video" ref="video" width="100%"></video>
                                            <div class="scan-confirmation" v-show="loadingDone.value">
                                                <i class="fa fa-check"></i>
                                            </div>
                                        </div>
                                    </div>
                                </CCol>
                            </CRow>
                            <CRow style="height: 500px; overflow: auto;">
                                <CCol sm="12" md="12" xl="12" xs="12">
                                    <CDataTable :items="itemAddSerial.stockProductLotSerials" :fields="productFields"
                                        :sorterValue="{ column: null, asc: 'true' }" ref="stockProductLots" hover>
                                        <template #stt="{ index }">
                                            <td>{{ index + 1 }}</td>
                                        </template>
                                        <template #serialId="{ item }">
                                            <td>
                                                {{ item.serialId }}
                                            </td>
                                        </template>
                                        <template #qrData="{ item }">
                                            <td>
                                                {{ item.qrData }}
                                            </td>
                                        </template>
                                        <template slot="no-items-view">
                                            <span style="color:#969696;">Danh sách trống!</span>
                                        </template>
                                        <template #action="{ item }">
                                            <td class="action-btn-group">
                                                <div class="action-btn-wrapper">
                                                    <CButton v-if="!isShowScan" color="danger" variant="outline" class="ml-1" square size="sm"
                                                        v-c-tooltip.hover="'Xóa'" @click="setupSelectOneAction('delete_one', item)">
                                                        <CIcon name="cil-trash" />
                                                    </CButton>
                                                </div>
                                            </td>
                                        </template>
                                    </CDataTable>
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>

        </div>
        <template v-slot:footer>
            <CButton color="secondary" class="btn-action-primary" @click="isShowModal = false"> <i
                    class="fa fa-times"></i> Đóng </CButton>
            <!-- <button type="button" class="btn btn-primary" @click="submitData()">
                <i class="fa fa-check"></i> Chọn
            </button> -->
        </template>

        <BaseFormLoading :value="loading.value"></BaseFormLoading>

        
        <CModal class="modal-add-line" title="Thêm mới" :show.sync="isShowModalAddLine" :closeOnBackdrop="false"
            :size="'sm'">
            <CRow class="pb-2">
                <CCol sm="12" md="12" xl="12" xs="12">
                    <BaseInput :options="hanlderLine.serialInput.options" :data="hanlderLine.serialInput.data" />
                </CCol>
                <CCol sm="12" md="12" xl="12" xs="12">
                    <BaseInput :options="hanlderLine.macInput.options" :data="hanlderLine.macInput.data" />
                </CCol>
                <CCol sm="12" md="12" xl="12">
                    <BaseTextArea :options="hanlderLine.qrDataInput.options" :data="hanlderLine.qrDataInput.data"
                        v-model="hanlderLine.qrDataInput.data.model" />
                </CCol>
            </CRow>
            <template v-slot:footer>
                <button type="button" class="btn btn-secondary" @click="isShowModalAddLine = false"><i class="fa fa-times"></i> Hủy bỏ
                </button>
                <button type="button" class="btn btn-primary" @click="submitAddLine()">
                    <i class="fa fa-save"></i> Lưu lại
                </button>
            </template>
            <BaseFormLoading :value="loading.value"></BaseFormLoading>
        </CModal>

        <ModalConfirm2 :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm2>
    </CModal>

</template>
    
<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseTextArea from '@/views/base/BaseTextArea'
import BaseFormLoading from "@/views/base/BaseFormLoading";
import ModalConfirm2 from '@/views/base/BaseModalConfirm2.vue';

export default {
    name: "StockProductLotModal",
    components: {
        BaseSwitch,
        BaseTable,
        ModalConfirm,
        BaseInput,
        BaseSelect,
        BaseFormLoading,
        BaseTextArea,
        ModalConfirm2
    },
    notifications: {
        showSuccessMsg: {
            type: "success",
            title: "Success"
        },
        showErrorMsg: {
            type: "error",
            title: "Error"
        },
        showWarningMsg: {
            type: "warn",
            title: "warn"
        }
    },
    props: ["itemAddSerial", "isDone"],
    data() {
        let that = this;

        let actionTypeMapping = new Map();
  
        actionTypeMapping.set("delete_one", {
            titlePopup: function () {
                return that.$helper.setupTitleAction(
                    "xóa bản ghi",
                    that.actionData.model.itemSelected.mac
                );
            },
            submitAction: function () {
                that.removeLine(that.actionData.model.itemSelected);
            },
        });

        return {
            loading: { value: false },
            isShowModal: true,
            loadingDone: { value: false },
            codeReader: null,
            streamMedia: null,
            isScanQR: false,
            isShowScan: this.isDone,
            isShowModalAddLine: false,
            actionData: {
                actionTypeMapping: actionTypeMapping,
                model: {
                    itemSelected: '',
                }
            },
            cameraSelect: {
                options: {
                    filter: false,
                    label: "Camera",
                    'keyField': 'deviceId',
                    'valueField': 'label',
                },
                data: {
                    name: "",
                    model: '',
                    items: [],
                }
            },
            scanQRDevice: {
                deviceSelected: null,
                devices: [],
                nameTimeout: null
            },
            productFields: [
                { key: 'stt', label: 'STT', _style: 'width: 5%;' },
                { key: 'serialId', label: 'Serial Id', _style: 'width: 20%;' },
                { key: 'mac', label: 'MAC', _style: 'width: 20%;' },
                { key: 'qrData', label: 'QR Data', _style: 'width: 10%;' },
                { key: 'action', label: 'Thao tác', _style: 'width: 10%;' },
            ],
            hanlderLine: {
                serialInput: {
                    options: {
                        label: "Serial Id <span class='required'>*</span>",
                        placeholder: "Serial Id",
                        type: "text",
                        maxlength: 256
                    },
                    data: {
                        name: "serialId",
                        model: "",
                        updateCallback: function () {
                            that.submitAddLine();
                        },
                        validator: {
                            isValid: true,
                            errorMessage: "",
                            valid: function () {
                                let value = that.hanlderLine.serialInput.data.model;
                                if (value === "") {
                                    this.isValid = false;
                                    this.errorMessage = "Serial Id không được để trống";
                                } else {
                                    this.isValid = true;
                                    this.errorMessage = "";
                                }
                                return this.isValid;
                            }
                        }
                    }
                },
                macInput: {
                    options: {
                        label: "MAC <span class='required'>*</span>",
                        placeholder: "MAC",
                        type: "text",
                        maxlength: 256
                    },
                    data: {
                        name: "mac",
                        model: "",
                        updateCallback: function () {
                            that.submitAddLine();
                        },
                        validator: {
                            isValid: true,
                            errorMessage: "",
                            valid: function () {
                                let value = that.hanlderLine.macInput.data.model;
                                if (value === "") {
                                    this.isValid = false;
                                    this.errorMessage = "MAC không được để trống";
                                } else {
                                    this.isValid = true;
                                    this.errorMessage = "";
                                }
                                return this.isValid;
                            }
                        }
                    }
                },
                qrDataInput: {
                    options: {
                        label: "QR Data",
                        placeholder: "QR Data",
                        maxlength: 1024,
                        rows: 5
                    },
                    data: {
                        name: "qrData",
                        model: "",
                        updateCallback: function () {
                            that.submitAddLine();
                        },
                        validator: {
                            isValid: true,
                            errorMessage: "",
                            valid: function () {
                                return this.isValid;
                            }
                        }
                    }
                },
            }
        };
    },
    methods: {
        generateUniqueId() {
            let existingIds = this.itemAddSerial.stockProductLotSerials.map(item => item.id)
            let newId;
            do {
                // Tạo ID mới, ví dụ: một chuỗi ngẫu nhiên có chiều dài 6
                newId = 'NEW' + Math.random().toString(36).substring(2, 8);
            } while (existingIds.includes(newId)); // Kiểm tra xem ID đã tồn tại chưa

            return newId;
        },
        submitData() {
            let that = this;
            that.isShowModal = false;
        },
        removeLine(item) {
            let that = this;
            const indexToRemove = that.itemAddSerial.stockProductLotSerials.findIndex(i => i.id === item.id);
            that.itemAddSerial.stockProductLotSerials.splice(indexToRemove, 1);
            if(!item.id.toString().includes('NEW')) {
                if(!that.itemAddSerial.lstIdRemoveStockPrdLot) {
                    that.itemAddSerial.lstIdRemoveStockPrdLot = [];
                }
                that.itemAddSerial.lstIdRemoveStockPrdLot.push(item.id);
            }
            this.changeData();
        },
        addLine(mac, serialId, qrData) {
            let existingMacs = this.itemAddSerial.stockProductLotSerials.map(item => item.mac);
            const macR = mac.replaceAll(':', '').replaceAll('\t', '').replaceAll('\r', '');
            if (!existingMacs.includes(macR)) {
                this.itemAddSerial.stockProductLotSerials.unshift({
                    serialId: serialId.replaceAll(':', '').replaceAll('\t', '').replaceAll('\r', ''),
                    mac: macR,
                    qrData: qrData,
                    id: this.generateUniqueId(),
                    productId: this.itemAddSerial.productId
                });
                this.changeData();
                this.updateLot();
            }
        },
        showAddLine() {
            this.hanlderLine.macInput.data.model = "";
            this.hanlderLine.serialInput.data.model = "";
            this.hanlderLine.qrDataInput.data.model = "";
            this.isShowModalAddLine = true;
        },
        submitAddLine() {
            let that = this;
            let isValid = true;
            isValid &= this.hanlderLine.macInput.data.validator.valid();
            isValid &= this.hanlderLine.serialInput.data.validator.valid();
            if (!isValid) {
                return;
            }

            that.addLine(this.hanlderLine.macInput.data.model, this.hanlderLine.serialInput.data.model, this.hanlderLine.qrDataInput.data.model);
            that.isShowModalAddLine = false;
        },
        async scanQR() {
            let that = this;
            this.loading.value = true;

            await this.loadCamera();

            this.scanQRDevice.devices = (await navigator.mediaDevices.enumerateDevices()).filter(
                (device) => device.kind === 'videoinput'
            )
            await this.timeout(500);
            if (this.scanQRDevice.devices.length > 0) {
                this.scanQRDevice.deviceSelected = this.scanQRDevice.devices[0];
            }
            this.isScanQR = true;
            this.start();
        },
        async onDetectScanQR(promise) {
            let that = this;
            await promise.then(async (data) => {
                that.scanQRDevice.loadingDone.value = true;
                that.scanQRDevice.nameTimeout = setTimeout(() => {
                    // code = data.content.substring(0, data.content.indexOf('\n'))
                    //         .replaceAll(':', '')
                    //         .replaceAll('\t', '')
                    //         .replaceAll('\r', '')
                    that.scanQRDevice.loadingDone.value = false;
                }, 2000);
            }).catch(err => {
                this.showErrorMsg({ message: 'Không thể quét QR thiết bị' })
            })
        },
        timeout(ms) {
            return new Promise((resolve) => {
                window.setTimeout(resolve, ms)
            })
        },
        paintBoundingBox(detectedCodes, ctx) {
            for (const detectedCode of detectedCodes) {
                const {
                    boundingBox: { x, y, width, height }
                } = detectedCode
                ctx.lineWidth = 4
                ctx.strokeStyle = '#007bff'
                ctx.strokeRect(x, y, width, height)
            }
        },
        async onInitQR(promise) {
            try {
                await promise.then(res => {
                    this.loading.value = false;
                })
            } catch (error) {
                if (error.name === 'NotAllowedError') {
                    this.showSuccessMsg({ message: "ERROR: you need to grant camera access permisson" });
                } else if (error.name === 'NotFoundError') {
                    this.showSuccessMsg({ message: "ERROR: no camera on this device" });
                } else if (error.name === 'NotSupportedError') {
                    this.showSuccessMsg({ message: "ERROR: secure context required (HTTPS, localhost)" });
                } else if (error.name === 'NotReadableError') {
                    this.showSuccessMsg({ message: "ERROR: is the camera already in use?" });
                } else if (error.name === 'OverconstrainedError') {
                    this.showSuccessMsg({ message: "ERROR: installed cameras are not suitable" });
                } else if (error.name === 'StreamApiNotSupportedError') {
                    this.showSuccessMsg({ message: "ERROR: Stream API is not supported in this browser" });
                }
            }
        },

        scanQrResult(value) {
            // let _code = '';
            // if (value.includes('\n')) {
            //     _code = value.substring(0, value.indexOf('\n'))
            // } else if (value.includes('|')) {
            //     _code = value.substring(0, value.indexOf('|'))
            // }
            // _code = _code.replaceAll(':', '')
            //     .replaceAll('\t', '')
            //     .replaceAll('\r', '')
            // console.log(value)
            let arr = [];
            if (value.includes('\n')) {
                arr = value.split('\n');
            } else if (value.includes('|')) {
                arr = value.split('|');
            }
            this.addLine(arr[0], arr[1], value);

            setTimeout(() => {
                this.loadingDone.value = false;
            }, 2000)
            
        },
        async loadCamera() {
            let that = this;
            this.loading.value = true;
            const constraints = {
                video: true,
                width: { ideal: 1920 }, // Độ phân giải theo chiều rộng
                height: { ideal: 1080 }, // Độ phân giải theo chiều cao
                facingMode: { exact: 'environment' }
            }
            await navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
                this.streamMedia = stream;
                this.codeReader = new ZXing.BrowserQRCodeReader();
                this.codeReader.getVideoInputDevices()
                    .then((videoInputDevices) => {
                        if (videoInputDevices.length >= 1) {
                            that.cameraSelect.data.items = videoInputDevices;
                            setTimeout(() => {
                                let isDeviceIOS = that.detectIOS();
                                if (!isDeviceIOS) {
                                    that.cameraSelect.data.model = videoInputDevices[0].deviceId;
                                } else {
                                    if (videoInputDevices.length > 1) {
                                        that.cameraSelect.data.model = videoInputDevices[1].deviceId;
                                    } else {
                                        that.cameraSelect.data.model = videoInputDevices[0].deviceId;
                                    }
                                }
                                that.$refs.video.addEventListener('loadedmetadata', () => {
                                    that.loading.value = false;
                                });
                            })

                        }
                    })
                    .catch((err) => {
                        console.error(err)
                    })
            }).catch(err => console.log(err));
        },
        decodeOnce() {
            let that = this;
            this.codeReader.decodeFromInputVideoDevice(this.cameraSelect.data.model, 'video').then((result, err) => {
                if (result) {
                    that.loadingDone.value = true;
                    setTimeout(() => {
                        this.scanQrResult(result.text)
                    }, 2000)
                }
                if (err) {
                    console.error(err)
                }
            })
                .catch(err => {
                    console.error(err)
                })
        },

        decodeContinuously() {
            this.codeReader.decodeFromInputVideoDeviceContinuously(this.selectedDeviceId, 'video', (result, err) => {
                if (this.loadingDone.value == false) {
                    if (result) {
                        // properly decoded qr code
                        // console.log('Found QR code!', result)
                        // document.getElementById('result').textContent = result.text
                        this.loadingDone.value = true;
                        this.scanQrResult(result.text)
                    }

                    if (err) {
                        // As long as this error belongs into one of the following categories
                        // the code reader is going to continue as excepted. Any other error
                        // will stop the decoding loop.
                        //
                        // Excepted Exceptions:
                        //
                        //  - NotFoundException
                        //  - ChecksumException
                        //  - FormatException

                        if (err instanceof ZXing.NotFoundException) {
                            console.log('No QR code found.')
                        }

                        if (err instanceof ZXing.ChecksumException) {
                            console.log('A code was found, but it\'s read value was not valid.')
                        }

                        if (err instanceof ZXing.FormatException) {
                            console.log('A code was found, but it was in a invalid format.')
                        }
                    }
                }

            })
        },

        start() {
            this.decodeContinuously();
        },
        reset() {
            if (this.codeReader) {
                this.codeReader.reset();
            }

        },
        stop() {
            if (this.streamMedia) {
                this.streamMedia.getTracks().forEach(track => track.stop());
            }
        },
        stopScanQR() {
            this.reset();
            this.stop();
            this.isScanQR = false;
        },
        restart() {
            this.reset();
            this.start();
        },
        detectIOS() {
            return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
                // iPad on iOS 13 detection
                || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        },
        loadData() {
            let that = this;
            if(!that.itemAddSerial.id.includes('NEW') && (!that.itemAddSerial.stockProductLotSerials || that.itemAddSerial.stockProductLotSerials.length == 0)) {
                this.$helper.loadDataSource({
                    loading: that.loading,
                    url: "/stock-line/find-lot-serial-by-line-id",
                    isJsonContentType: false,
                    dataSubmit: function () {
                        return { stockLineId: that.itemAddSerial.id }
                    },
                    successCallback: function (response) {
                        that.itemAddSerial.stockProductLotSerials = response.data.data;
                        that.loading.value = false
                    },
                    errorCallback: function (error) {
                        that.$helper.handleError(that.$router, error);
                        that.loading.value = false;
                    }
                });
            }
        },
        changeData() {
            this.itemAddSerial.quantity = this.itemAddSerial.stockProductLotSerials.length;
            this.$emit("sum-total");
        },
        updateLot() {
            this.itemAddSerial.isUpdateLot = true;
        },
        setupSelectOneAction: function (actionTypeKey, item) {
            let actionData = this.actionData.model;
            actionData.itemSelected = item || null;
            this.$refs.actionModal.setCurrAction(actionTypeKey);
        },
    },
    created: function () {
        
    },
    mounted() {
        this.loadData()
    },
    watch: {
        'cameraSelect.data.model': function () {
            this.restart();
        },
        'itemAddSerial.stockProductLotSerials.length': function() {
            this.updateLot();
            this.changeData();
        },
        isShowModal: function (value) {
            if (!value) {
                this.reset();
                this.stop();
                this.$emit("close-modal", false);
            }
        },
    },
    destroyed() {
        this.stop();
    },
    computed: {
    }
};
</script>
<style scoped>
.scan-confirmation {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: rgba(255, 255, 255, 0.8);

    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
}

.scan-confirmation>i {
    font-size: 100px;
    font-weight: 700;
    color: green;
}
</style>